module.exports = __webpack_public_path__ + "img/inst.f0e6b065.svg";